(() => {
  const rootUrl = window.Shopify?.routes?.root || '/';

  document.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-buy-now]');
    if (!button || button.disabled || button.getAttribute('aria-disabled') === 'true') return;

    const productForm = button.closest('product-form');
    const form = productForm?.querySelector('form');
    if (!form) return;

    event.preventDefault();
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');

    try {
      const response = await fetch(`${rootUrl}cart/add.js`, {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: new FormData(form),
      });

      if (!response.ok) throw new Error('Unable to add this selection to checkout.');
      window.location.assign(`${rootUrl}checkout`);
    } catch (error) {
      button.disabled = false;
      button.removeAttribute('aria-busy');
      productForm?.handleErrorMessage?.(error.message);
    }
  });
})();
